module.exports = __webpack_public_path__ + "static/media/step1.1fd641d5.svg";